import cx from 'clsx';

import { Image } from '@shared/components/core';
import { POWERED_BY } from '@shared/constants';

import phonePeLogo from '@assets/icons/ppLogo.svg';

import styles from './PhonePeBrand.module.scss';

const PhonePeBrand = ({ showPoweredBy = true, wrapperClassName = '' }) => (
	<div className={cx('d-flex items-center', wrapperClassName)}>
		{showPoweredBy && <span className="h5 lighter dark2"> {POWERED_BY} </span>}
		<Image
			src={phonePeLogo}
			className={styles.brandLogo}
			alt="PhonePe"
			loading="eager"
		/>
	</div>
);
export default PhonePeBrand;
